
document.addEventListener('touchend', (e) => {
  if(e.target.id === 'open-popup' || e.target.parentElement.id === 'open-popup'){
    const popup = document.getElementById('about-popup');
    popup.classList.toggle('hidden');
  }
})
document.addEventListener('click', (e) => {
  if(e.target.id === 'open-popup' || e.target.parentElement.id === 'open-popup'){
    const popup = document.getElementById('about-popup');
    popup.classList.toggle('hidden');
  }
})
